import { SkuPrice } from "./sku-price";

export class PricingDataDto {
  constructor(
    public skuId: number,
    public prices: Array<SkuPrice>
  ) { }
}
